<div class="review-component">
  <div class="summary-grid">
    <div class="card contact">
      <h4>Contact Information</h4>
      <div class="row two">
        <label class="label-bold">Submitters Email
        </label>
        <label>{{this.cartData?.deliveryAddress?.email}}
        </label>
      </div>
      <div class="row two">
        <label class="label-bold">First Name
        </label>
        <label>{{this.cartData?.deliveryAddress?.firstName}}
        </label>
      </div>
      <div class="row two">
        <label class="label-bold">Last Name
        </label>
        <label>{{this.cartData?.deliveryAddress?.lastName}}
        </label>
      </div>
      <div class="row two">
        <label class="label-bold">Company
        </label>
        <label>{{this.cartData?.deliveryAddress?.companyName}}
        </label>
      </div>
      <div class="row two">
        <label class="label-bold">Phone
        </label>
        <label>{{getFormattedPhone()}}
        </label>
      </div>
    </div>

    <div class="card shipping">
      <h4>Shipping Address</h4>
      @if(isLabels){
      <div class="row one"> <label>Plant Location :</label><label>{{this.cartData?.deliveryAddress?.labelsPlantName}}</label> </div>
      }
      <div class="row one"> <label>{{this.cartData?.deliveryAddress?.line1}}</label> </div>
      <div class="row one"> <label>{{this.cartData?.deliveryAddress?.line2}}</label> </div>
      <div class="row one"> <label>{{this.cartData?.deliveryAddress?.city}}</label> </div>
      <div class="row one"> <label>{{this.cartData?.deliveryAddress?.region?.name}}</label> </div>
      <div class="row one"> <label>{{this.cartData?.deliveryAddress?.postalCode}}</label> </div>
      <div class="row one"> <label>{{this.cartData?.deliveryAddress?.country?.name}}</label> </div>
      <div class="row one"> <label>Phone: {{getFormattedPhone()}}</label> </div>
    </div>
  </div>
  @if(!isLabels){
  <div class="card shipping mt-3">
    @if(this.cartData?.overnightShipping==false){
    <h4>Shipping Method</h4>
    <div class="row one">
      <label class="label-bold">Overnight Shipping &nbsp;&nbsp;&nbsp; No
      </label>
    </div>
    }
    @else{

    <div class="row col-12 p-0">
      <div class="col-6 p-0">
        <h4>Shipping Method</h4>
        <div class="row two">
          <label class="label-bold">Overnight Shipping
          </label>
          <label>{{this.cartData?.overnightShipping?'Yes':'No'}}
          </label>
        </div>
        <div class="row two">
          <label class="label-bold">Overnight Carrier
          </label>
          <label>{{this.cartData?.overnightCarrier}}
          </label>
        </div>
        <div class="row two">
          <label class="label-bold">Account Number
          </label>
          <label>{{this.cartData?.overnightAccountNumber}}
          </label>
        </div>
        <h4>Billing Address</h4>
        <div class="row two">
          <label class="label-bold">Charge Name:
          </label>
          <label>{{this.cartData?.paymentAddress?.carrierChargerName}}
          </label>
        </div>
        <div class="row two">
          <label class="label-bold">Address 1
          </label>
          <label>{{this.cartData?.paymentAddress?.line1}}
          </label>
        </div>
        <div class="row two">
          <label class="label-bold">Address 2
          </label>
          <label>{{this.cartData?.paymentAddress?.line2}}
          </label>
        </div>
        <div class="row two">
          <label class="label-bold">City
          </label>
          <label>{{this.cartData?.paymentAddress?.city}}
          </label>
        </div>
        <div class="row two">
          <label class="label-bold">State / Province / District
          </label>
          <label>{{this.cartData?.paymentAddress?.region?.name}}
          </label>
        </div>
        <div class="row two">
          <label class="label-bold">Zip / Postal Code
          </label>
          <label>{{this.cartData?.paymentAddress?.postalCode}}
          </label>
        </div>
        <div class="row two">
          <label class="label-bold">Country / Region
          </label>
          <label>{{this.cartData?.paymentAddress?.country?.name}}
          </label>
        </div>
      </div>
    </div>
    }
  </div>
}

  <div class="cart-summary-layout mt-3">
    <div class="cart-table-card">
      <div class="cart-table-header" aria-label="Shopping cart columns">
        <span class="header-product">Product</span>
        <span class="header-cell">Material #</span>
        <span class="header-cell">Qty</span>
        <span class="header-cell">Sales Unit</span>
      </div>

      @for (item of cartItems; track item.id) {
      <div class="cart-item-row">
        <div class="product-cell">
          <div class="product-thumb" [class.small]="item.compactThumb" aria-hidden="true">
            <cx-media [container]="item.product?.images?.PRIMARY" [format]="'cartIcon'"
              [alt]="item?.product?.images?.altText">
            </cx-media>
          </div>
          <div class="product-details">
            {{ item.name }}
          </div>
        </div>
        <div class="value-cell">{{ item.partNumber }}</div>
        <div class="value-cell">
          {{ item.quantity }}
        </div>
        <div class="value-cell">
          {{ item.salesUnit }}
        </div>
        @if (item.overageReason?.trim()) {
        <div class="overage-reason-cell">
          <span class="overage-reason-label">Reason for quantity overage:</span>
          <span>{{ item.overageReason }}</span>
        </div>
        }
      </div>
      }
      <div class="cart-total">Total Items: <strong>{{ cartItems.length }}</strong></div>
    </div>
  </div>

  <div class="comments mt-3">
    <label>Comments : </label>
    <label>{{this.cartData?.deliveryAddress?.note || 'No comments provided.'}}</label>
  </div>
</div>
